import { useVehicleNumber } from '@sravni/cosago-react-library/lib/hooks';
import { vehicleNumberScheme } from '@sravni/cosago-react-library/lib/validationSchemes';

import { useAppDispatch } from 'shared/lib/redux';

import type { TPledgeAutoFields } from 'entities/pledgeAutoForm';
import { tryLoadDataByCarNumberThunk } from 'entities/pledgeAutoForm/lib/tryLoadDataByCarNumberThunk';

export const usePrefillCarInfo = (carNumberFieldName: string, onUpdateData: (data: TPledgeAutoFields) => void) => {
  const { currentNumber } = useVehicleNumber(carNumberFieldName);
  const isNumberValid = vehicleNumberScheme().isValidSync(currentNumber);
  const dispatch = useAppDispatch();

  const prefillFieldsByCarNumber = async () => {
    if (!currentNumber || !isNumberValid) {
      return;
    }

    try {
      const mappedData = await dispatch(tryLoadDataByCarNumberThunk(currentNumber));
      if (mappedData) {
        onUpdateData(mappedData);
      }
    } catch (e) {}
  };

  return {
    prefillFieldsByCarNumber,
  };
};
